import { IClientTimelineEntry } from "@cosine/types/api-models";

export default function (timelineEntry: IClientTimelineEntry): Array<string> {
  return timelineEntry.Attachments.flatMap((attachment) => {
    return attachment.Payloads?.map((payload) => payload.TypeName) || [];
  });
}
